import React from 'react';
import { ColumnHeader } from 'components/organisms/projects-report/common';
import { sortByText } from 'utils/sort-by-text';
import { numberSorter } from 'utils/sorters';
import { getTableCellRender, TableFieldTypes } from '../components';

export interface CompareObjectType {
  value: number;
  cmpValue: number;
}

export interface ColumnOptions {
  isTemplateColumnRequired: boolean | undefined;
}

const sorterFunc = (a, b, fieldType) => {
  switch (fieldType) {
    case TableFieldTypes.Number:
    case TableFieldTypes.Days:
    case TableFieldTypes.Time:
    case TableFieldTypes.Percentage: {
      return numberSorter(a, b);
    }
    case TableFieldTypes.TimeWithPercentage:
    case TableFieldTypes.CompareValue: {
      return numberSorter(a.value, b.value);
    }
    case TableFieldTypes.String: {
      return sortByText(a, b);
    }
    default:
      return -1;
  }
};

export const toColumnDef = (
  columnItem: { [key: string]: any },
  getColumnTitle: (key: string) => string,
): { [key: string]: any } => ({
  showSorterTooltip: false,
  dataIndex: columnItem.key,
  render: getTableCellRender({
    fieldName: columnItem.key,
    fieldType: columnItem.fieldType,
  }),
  sorter: (a, b) =>
    sorterFunc(a[columnItem.key], b[columnItem.key], columnItem.fieldType),
  title: <ColumnHeader title={getColumnTitle(columnItem.key)} />,
  ...columnItem,
});

export const predictIfTemplateRequired = (
  key: string,
  isRequired?: boolean,
): boolean => !(key === 'templateName' && !isRequired);
